import React from 'react';

import {getFormattedDate} from '../../utils/datetime';
import IPayment from '../../models/IPayment';
import PaymentStatusBadge from '../Status/PaymentStatusBadge';
import {PaymentStatus} from '../../models/PaymentStatus';
import {ROBOKASSA_PAYMENT_PAGE} from '../../constants/urls';

interface IPaymentRowProps {
    item: IPayment,
    tzString?: string | null,
}

const PaymentRow: React.FC<IPaymentRowProps> = ({item, tzString}) => {

    return (
        <tr>
            <td>{item.number}</td>
            <td>{getFormattedDate(item.created_at, {tzString})}</td>
            <td>{item.sum} руб</td>
            <td>{item.tariff.name}</td>
            <td><PaymentStatusBadge status={item.status}/></td>
            <td>{getFormattedDate(item.payed_at, {tzString})}</td>
            <td>
                {
                    item.status === PaymentStatus.Created
                    && item.invoice_id
                    // eslint-disable-next-line react/jsx-no-target-blank
                    && <a
                        href={ROBOKASSA_PAYMENT_PAGE(item.invoice_id)}
                        target="_blank"
                    >Оплатить</a>
                }
            </td>
        </tr>
    );
};

export default PaymentRow;